// extracted by mini-css-extract-plugin
export default {"section":"Ru-z","sectionTitle":"Su-z","fieldWrapper":"Tu-z","formField":"Uu-z","disabled":"Vu-z","formLabel":"Wu-z"};